import { render, staticRenderFns } from "./ContractCustomerTabs.vue?vue&type=template&id=4776fb24"
import script from "./ContractCustomerTabs.vue?vue&type=script&lang=js"
export * from "./ContractCustomerTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports